// i18n area 'vms' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.pt-PT.meta.json.
import type { enUS } from './vms'

export const ptPT: typeof enUS = {
  vms: {
    spof: {
      title: 'Independência do nó',
      single: 'Ponto único de falha',
      alternativesNow: 'Alternativas agora',
      structural: 'Por construção',
      binding: 'Restrição vinculativa',
      movableNow: 'Migrável agora',
    },
    title: 'Máquinas virtuais',
    migratingChip: 'Migração em curso',
    templateChip: 'Template',
    expendableTooltip: 'Num cluster degradado está entre as primeiras a cair e pode não reiniciar após a perda de um nó.',
    expendableHaTooltip: 'Sempre reiniciada enquanto o cluster está saudável; num cluster degradado as VMs protegidas vêm primeiro — pode ser parada ou ficar desligada até o cluster voltar a estar completo, depois volta sozinha.',
    viewDetails: 'Ver detalhes',
    profileLegacy: 'Outro OS',
    hugePagesNone: 'Nenhuma — memória normal',
    hugePages2M: 'Páginas de 2 MiB',
    hugePages1G: 'Páginas de 1 GiB',
    searchPlaceholder: 'Pesquisar por nome',
    name: 'Nome',
    vcpus: 'vCPU',
    memory: 'Memória',
    ipAddresses: 'Endereços IP',
    noIp: 'Sem IP',
    authorityNode: 'Authority',
    authorityNextStart: 'atribuída no próximo arranque',
    scope: 'Scope',
    empty: 'Nenhuma máquina virtual',
    loadError: 'Não foi possível carregar as máquinas virtuais — o backend TVirt está alcançável?',
    filterOverlay: 'rede overlay',
    filterDisk: 'disco',
    filterImage: 'imagem',
    filteredBy: 'Filtradas por {kind}',
    filterPhase: 'Fase',
    filterProtection: 'Proteção',
    filterAll: 'Todas',
    filterScopePlaceholder: 'Filtrar por scope',
    filtersToggle: 'Filtros',
    scopeTree: {
      title: 'Scopes',
      all: 'Todo o cluster',
      noChildren: 'Nenhum sub-scope aqui',
      recursive: 'Incluir descendentes',
      collapse: 'Recolher o painel de scopes',
      up: 'Subir um nível',
      countTooltip: '{direct} VMs neste scope · {total} com os descendentes'
    },
    isoPicker: {
      catalog: 'Catálogo',
      unknownCatalog: 'Fora dos catálogos visíveis',
      noIsos: 'Nenhuma imagem ISO pronta neste catálogo'
    },
    actionsHeader: 'Ações',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Idade',
      disk: 'disco',
      disks: 'discos',
      empty: 'Nenhum template — marque como template uma VM desligada, ou clone uma VM como template.',
      clone: 'Clonar / deploy',
      editTags: 'Editar tags',
      exportAction: 'Exportar para o catálogo (.tvtpl)',
      exportTitle: 'Exportar para o catálogo',
      exportSubmit: 'Exportar',
      exportError: 'A exportação falhou',
      exportHint: 'O template é empacotado num arquivo .tvtpl (manifest de hardware + cada disco achatado em qcow2) como novo ficheiro Template VM no catálogo escolhido. NICs, suportes CD/DVD e cloud-init não viajam — a spec do formato lista cada omissão deliberada.',
      exportName: 'Nome do ficheiro',
      exportNameHint: 'Vazio = <template>-export-<n>',
      exportStorageDefault: 'O storage de metadados do template',
      importAction: 'Importar do catálogo',
      importTitle: 'Importar do catálogo',
      importHint: 'Um ficheiro Template VM ready do catálogo escolhido torna-se um template do inventário: o formato do ficheiro (tvtpl, ova, ovf ou qcow2 nu) decide sozinho como se importa — escolhe-se apenas o ficheiro.',
      importFile: 'Ficheiro de catálogo',
      importFileHint: 'Só se importam ficheiros ready — um a meio do upload não é importável',
      importNoFiles: 'Nenhum ficheiro Template VM ready neste catálogo — carregue ou exporte um primeiro'
    },
    templateDetail: {
      quickDeploy: 'Compatibilidade QuickDeploy',
      quickDeployNone: 'Não declarada',
      quickDeployHint: 'Declare-a apenas se a imagem golden contiver cloud-init (Linux) ou cloudbase-init após sysprep /generalize (Windows): a plataforma confia na declaração e nunca olha para dentro do guest.',
      notFound: 'Template não encontrado',
      frozen: 'A configuração de hardware está congelada: reconverta o template em VM para a alterar. Nome, notas e tags continuam editáveis.',
      storage: 'Storage',
      size: 'Tamanho',
      configTitle: 'Configuração (congelada)',
      usbClasses: 'Classes USB exigidas',
      gpuClasses: 'Classes GPU exigidas'
    },
    sharedDisksTab: {
      title: 'Discos partilhados',
      sharing: 'Partilha',
      sharingNone: 'Um só attach',
      sharingMultiwriter: 'Escrita partilhada (multiwriter)',
      sharingReadonly: 'Só leitura partilhada',
      usedBy: 'Em uso por',
      attachedTo: 'Ligado a',
      notAttached: 'Ligado a nenhuma VM',
      changeSharing: 'Alterar modo de partilha',
      changeSharingTitle: 'Modo de partilha',
      changeSharingLocked: 'O modo só muda enquanto nenhuma VM usa o disco',
      sharingChanged: 'Modo de partilha atualizado.',
      lun: 'LUN inteira',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Série',
      antiAffinityWarning: 'Dois ou mais membros correm no mesmo nó sem regra de anti-afinidade: a falha de um nó derruba todos',
      antiAffinityCreate: 'Criar a regra',
      createSourceLun: 'Adotar uma LUN inteira do target',
      createLunNumber: 'Número da LUN (id de namespace em NVMe)',
      createLunHint: 'Nada é alocado: o tamanho é observado no dispositivo na adoção',
      noPr: 'Nesta versão não há SCSI-3 persistent reservations: um Windows Failover Cluster com disco partilhado clássico não está validado; os clusters que coordenam pela rede (GFS2/OCFS2, RHEL HA, bases de dados de disco partilhado) estão'
    },
    unusedDisksTab: {
      title: 'Discos não usados',
      attach: 'Ligar a uma VM',
      attachTitle: 'Ligar a uma VM',
      vm: 'Máquina virtual',
      noVms: 'Nenhuma VM disponível',
      noSlots: 'Nenhum slot livre nesta VM',
      create: 'Criar disco',
      createTitle: 'Criar disco',
      createSourceBlank: 'Disco vazio',
      createSourceImage: 'A partir de uma imagem do catálogo',
      createImage: 'Imagem',
      createImageEmpty: 'Nenhuma imagem de modelo de VM pronta nos catálogos visíveis',
      createSizeFromImageHint: 'Pré-preenchido com o tamanho virtual da imagem — só pode crescer',
      convert: 'Converter em template VM…',
      convertOnlyQcow2: 'Só se convertem discos qcow2 — raw não é um formato de template registável',
      convertTitle: 'Converter em template VM',
      convertSubmit: 'Converter (destrói o disco)',
      convertError: 'Não foi possível iniciar a conversão',
      convertWarning: 'DESTRUTIVO: o disco torna-se um ficheiro template VM no catálogo escolhido — mesmo storage, zero bytes copiados — e DEIXA DE EXISTIR como disco. Não há retorno a não ser criando um novo disco a partir do template.',
      convertNameHint: 'O nome do ficheiro de catálogo — por predefinição o do disco',
      convertConfirm: 'Compreendi: o disco será destruído',
      convertStarted: 'Conversão iniciada — o template aparece no catálogo no fim da task.',
      storageLockHint: 'O storage só muda através da ação Mover',
      source: 'Proveniência',
      sourceClone: 'Clone de outro disco',
      sourceCloneLinked: 'Linked clone de outro disco',
      sourceImage: 'Criado a partir de uma imagem',
      sourceBlank: 'Criado vazio',
      allocated: 'Alocado / tamanho virtual',
      observedAt: 'Observado em',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Nenhum snapshot'
    },
    phase: {
      defined: 'Nunca ligada',
      starting: 'A arrancar',
      running: 'Em execução',
      stopping: 'A parar',
      stopped: 'Desligada',
      paused: 'Em pausa',
      failed: 'Em erro',
      deleting: 'Em eliminação'
    },
    stopCause: {
      'api': 'Parada pelo TVirt (ação ou API)',
      'guest-shutdown': 'Shutdown iniciado pelo sistema operativo guest',
      'crash': 'Crash do guest',
      'qemu-exit': 'O processo QEMU terminou de forma inesperada',
      'host-reboot': 'O nó foi reiniciado',
      'migrated': 'Migrada para outro nó',
      'fenced': 'Terminada pelo fencing HA (nó regressado)'
    },
    detail: {
      notFound: 'Máquina virtual não encontrada',
      details: 'Detalhes',
      id: 'ID',
      scope: 'Scope',
      profile: 'Perfil de hardware',
      firmware: 'Firmware',
      firmwareFile: 'Versão do firmware UEFI',
      firmwareUpdate: 'Atualização disponível',
      firmwareUpdateHint: 'A plataforma inclui um firmware UEFI mais recente. A atualização nunca é automática: aplica-se com a VM desligada, quando você decidir.',
      arch: 'Arquitetura',
      node: 'Nó',
      bootOrder: 'Ordem de boot',
      agent: 'Estado do agent',
      agentConnected: 'Ligado',
      agentNotConnected: 'Não ligado',
      protected: 'Protegida',
      linkedClones: 'Clones ligados',
      restartPolicy: 'Política de reinício',
      preferredNode: 'Nó preferido',
      noPreference: 'Sem preferência (colocação automática)',
      preferNodes: 'Tags de nó preferidas',
      requireNodes: 'Tags de nó obrigatórias',
      noPlacementTags: 'Nenhuma',
      placementTag: 'Tag',
      placementValue: 'Valor',
      placementAddTag: 'Adicionar tag',
      proximityHa: 'HA do TVirt Proximity',
      proximityHaRestarts: 'reinícios HA',
      proximityHaGaveUp: 'crash loop — a HA desistiu',
      failoverProtection: 'Proteção em degradado',
      protectionProtected: 'Protegida',
      protectionExpendable: 'Sacrificável em degradado',
      protectionInherit: 'Herdar',
      lastStop: 'Última paragem',
      yes: 'Sim',
      no: 'Não',
      tabOverview: 'Visão geral',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Cópias',
      hardware: 'Hardware',
      name: 'Nome',
      hwSystem: 'Sistema',
      hwCpu: 'CPU',
      hwMemory: 'Memória',
      hwBoot: 'Arranque',
      hwIdentity: 'Identidade',
      hwCluster: 'Cluster e agent',
      cpuTopology: 'Topologia de CPU',
      cpuModel: 'Modelo de CPU',
      cpuLimit: 'Limite de CPU',
      cpuWeight: 'Peso de CPU',
      cpuNested: "Virtualização aninhada",
      cpuNestedHint: "Expõe vmx/svm ao convidado (apenas com o modelo de CPU host). Numa VM ligada, a alteração aplica-se no próximo power cycle (PendingRestart); a colocação só admite nós com nested ativado.",
      unlimited: 'Ilimitado',
      memory: 'Memória',
      balloon: 'Balloon',
      hugePages: 'Páginas enormes',
      hugePagesTradeoff: 'Menos trabalho de tradução de endereços e memória que nunca vai para o disco; em troca a reserva fica bloqueada no nó enquanto a VM está ligada, a memória deixa de ser deduplicada e o arranque falha se o nó não tiver páginas livres suficientes.',
      disks: 'Discos',
      cdroms: 'Leitores CD/DVD',
      nics: 'Interfaces de rede',
      slot: 'Slot',
      disk: 'Disco',
      encrypted: 'Cifrado',
      image: 'Imagem',
      emptyDrive: 'Leitor vazio',
      emptyOption: '(vazio)',
      network: 'Rede',
      mac: 'MAC',
      connected: 'Ligada',
      unplugged: 'Desligada',
      noDevices: 'Nenhum',
      screenshot: 'Screenshot',
      capturedAt: 'Capturado às',
      noCapture: 'Nenhuma captura',
      snapshotName: 'Nome',
      snapshotCreated: 'Criado',
      snapshotMemory: 'Memória incluída',
      noSnapshots: 'Nenhum snapshot',
      pendingRestart: 'Alterações pendentes: serão aplicadas no próximo power cycle.',
      applied: 'aplicado',
      appliedHint: 'A VM está a correr com este valor — o configurado aplica-se no próximo power cycle.',
      actionError: 'A ação falhou',
      actionStillRunning: 'A ação ainda está em curso — o resultado ainda não é conhecido',
      tabConsole: 'Consola',
      consoleConnect: 'Ligar',
      consoleDisconnect: 'Desligar',
      consoleConnecting: 'A ligar…',
      consoleReconnecting: 'A ligar…',
      consoleUnavailable: 'A consola está disponível com a VM em execução ou em pausa.',
      consoleError: 'A ligação à consola falhou',
      consoleTaken: 'Sessão de consola tomada por {user}',
      consoleReconnect: 'Voltar a ligar',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Mantenha {key} premido',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Abrir em ecrã inteiro num novo tab',
      consoleLoadFailed: 'VM não encontrada ou permissões insuficientes',
      consoleClose: 'Fechar',
      tabStats: 'Estatísticas',
      tabTasks: 'Tasks',
      tabLogs: 'Logs',
      statsCpu: 'CPU',
      statsMemory: 'Memória',
      statsDisk: 'I/O de disco',
      statsRange: 'Intervalo',
      statsNoData: 'Sem dados no intervalo — as estatísticas são amostradas com a VM em execução.',
      statsError: 'Não foi possível carregar as estatísticas',
      cpuUsage: 'Utilização',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Usada',
      memGuestAvailable: 'Disponível (guest)',
      schema: 'Schema',
      consoleProtocol: 'Consola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage de metadados',
      startupOnBoot: 'Arranque no boot',
      startupOrder: 'Ordem de arranque',
      startupDelay: 'Atraso de arranque',
      seconds: 's',
      enabled: 'Ativado',
      disabled: 'Desativado'
    },
    actionsAvailable: 'Ações disponíveis',
    actions: {
      start: 'Arrancar',
      stop: 'Parar',
      pause: 'Pausa',
      resume: 'Retomar',
      reset: 'Reset',
      migrate: 'Migrar',
      clone: 'Clonar',
      moveStorage: 'Mover para storage…',
      moveScope: 'Mover para scope…',
      openConsole: 'Abrir consola',
      forceStop: 'Forçar paragem',
      markTemplate: 'Marcar como template',
      unmarkTemplate: 'Reconverter em VM',
      error: 'Não foi possível executar a ação'
    },
    cordon: {
      confirmTitle: 'O nó está em manutenção',
      confirmHint:
        'O cordão não pode ser baixado enquanto o store do cluster estiver em baixo. Ao confirmar declaras que sabes: a VM liga-se lá de qualquer forma, e o consentimento fica registado na tarefa.',
      confirm: 'Ligar mesmo assim'
    },
    markTemplate: {
      confirmTitle: 'Marcar {name} como template?',
      confirmBody: 'A configuração congela-se e a VM já não poderá ligar-se — apenas ser clonada, ou voltar a VM. Nome, notas e tags continuam editáveis.',
      confirm: 'Marcar como template',
      moved: '{name} agora é um template — passou para o tab Templates.'
    },
    unmarkTemplate: {
      confirmTitle: 'Reconverter {name} em VM?',
      confirmBody: 'O template volta a ser uma VM comum: editável e arrancável (o próximo arranque coloca-a num nó).',
      confirm: 'Reconverter em VM',
      moved: '{name} é de novo uma máquina virtual — passou para o tab Máquinas virtuais.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Por tag de nó',
      hint: 'tag=valor, separados por vírgulas (em AND): o decider escolhe entre os nós correspondentes',
      invalid: 'Formato inválido — use tag=valor, separados por vírgulas',
      resolved: 'Membros correspondentes: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrar',
      target: 'Nó de destino',
      auto: 'Automático (Proximity)',
      hint: 'A VM move-se sem power cycle. Cada storage que toca tem de ser partilhado; uma VM em pausa migra em pausa.',
      error: 'A migração foi recusada'
    },
    moveStorage: {
      title: 'Mover para storage',
      submit: 'Mover',
      target: 'Storage de destino',
      noTargets: 'Nenhum storage aceita discos',
      hint: 'Todos os discos da VM desligada viajam para o storage escolhido, um de cada vez, mantendo o seu id — os que já lá estão são saltados. O progresso vive na página de tasks.',
      error: 'A mudança de storage foi recusada'
    },
    moveScope: {
      title: 'Mover para scope',
      submit: 'Mover',
      target: 'Scope de destino',
      hint: 'A VM muda de scope imediatamente — id e discos ficam, os discos owned seguem-na, e pode ficar ligada. Hoje vive em {scope}. Quem a vê muda com o scope.',
      error: 'A mudança de scope foi recusada'
    },
    start: {
      title: 'Arrancar VM',
      submit: 'Arrancar',
      target: 'Nó de destino',
      auto: 'Automático (recomendado)',
      recommended: 'recomendado',
      hint: 'Escolha um nó de destino ou deixe o Proximity decidir entre os candidatos válidos. Os nós que não a podem alojar estão desativados com o motivo.',
      error: 'Não foi possível arrancar a VM'
    },
    console: {
      media: 'Leitores CD/DVD',
      mediaGuestToolsHint: 'Contém as TVirt Guest Tools — daqui pode ejetá-las ou remover o leitor',
      slotOpsDeferred: 'Neste perfil, adicionar e remover leitores aplica-se no próximo power cycle (as mudanças de suporte são imediatas).',
      mountGuestTools: 'Montar TVirt Guest Tools',
      ejectGuestTools: 'Ejetar TVirt Guest Tools',
      bootOrder: 'Ordem de boot',
      bootOrderHint: 'A nova ordem guarda-se logo e aplica-se no próximo power cycle — a sessão de consola fica ligada.'
    },
    snapshots: {
      create: 'Criar snapshot',
      createTitle: 'Criar um snapshot',
      createSubmit: 'Criar',
      name: 'Nome',
      nameHint: 'Letras, dígitos, ponto, hífen, underscore.',
      consistencyHint: 'A consistência é automática: o guest agent congela os filesystems quando responde; caso contrário a VM entra em pausa por um instante à volta do snapshot.',
      memory: 'Incluir a memória',
      memoryHint: 'Captura a RAM viva: o restauro retoma a VM em execução. Exige todos os discos qcow2.',
      currentChip: 'Está aqui',
      revert: 'Restaurar',
      revertTitle: 'Restaurar {name}?',
      revertBody: 'Os discos voltam ao estado do snapshot; tudo o que aconteceu depois perde-se. Um snapshot só de discos exige a VM parada.',
      delete: 'Eliminar',
      deleteTitle: 'Eliminar o snapshot {name}?',
      deleteBody: 'O ponto de restauro desaparece; o conteúdo dos discos fica intacto.',
      deleteMergeHint: 'O seu delta funde-se em {children}: cada ponto de restauro posterior continua válido.',
      deleteDuplication: 'Aceito a duplicação',
      deleteDuplicationHint: 'O delta é copiado para cada um dos {count} leitores (os snapshots filhos e, se este for o atual, a cabeça ativa): o espaço ocupado pode crescer em vez de diminuir.',
      error: 'A operação sobre o snapshot foi recusada'
    },
    clone: {
      title: 'Clonar VM',
      submit: 'Clonar',
      name: 'Nome da cópia',
      storage: 'Storage de destino dos discos',
      sameStorage: 'O mesmo da origem',
      full: 'Cópia completa',
      fullHint: 'Copia cada byte e corta o laço com os discos de origem. O default é um linked clone: instantâneo, mas encadeado à origem (só qcow2).',
      hint: 'O clone mantém a configuração e o firmware da origem; os endereços MAC e a identidade TPM são novos.',
      markAs: 'Tipo do clone',
      markAsInheritVm: 'Como a origem (VM)',
      markAsInheritTemplate: 'Como a origem (template)',
      markAsVm: 'Máquina virtual',
      markAsTemplate: 'Template',
      markAsHintVm: 'Escolha Template para promover a cópia num só passo.',
      markAsHintTemplate: 'Escolha Máquina virtual para fazer o deploy deste template num só passo.',
      error: 'A clonagem foi recusada'
    },
    bulk: {
      selected: 'selecionadas',
      deleteTitle: {
        one: 'Eliminar {count} VM selecionada?',
        many: 'Eliminar {count} VMs selecionadas?',
        other: 'Eliminar {count} VMs selecionadas?'
      },
      deleteBody: 'Cada VM passa pelas mesmas guardas do delete individual; as recusas são reportadas por elemento.',
      done: 'aceites',
      refused: 'recusadas'
    },
    delete: {
      button: 'Eliminar',
      confirmTitle: 'Eliminar {name}?',
      confirmBody: 'A máquina virtual e os discos que lhe pertencem serão eliminados. A operação não é reversível.',
      keepDisks: 'Manter os discos',
      keepDisksHint: 'Os discos criados com a VM ficam no seu storage como discos autónomos.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
      error: 'A eliminação falhou',
      blockedPhase: 'Pare primeiro a VM',
      blockedProtected: 'A VM está protegida — remova primeiro a proteção',
      blockedDeleting: 'Eliminação já em curso'
    },
    logs: {
      title: 'Logs',
      subtitle: 'Frames de log estruturados das tasks que tocam esta VM',
      when: 'Quando',
      task: 'Task',
      level: 'Nível',
      message: 'Mensagem',
      empty: 'Ainda nenhum log',
      loadError: 'Não foi possível carregar os logs — o backend TVirt está alcançável?'
    },
    stop: {
      title: 'Parar máquina virtual',
      modeGraceful: 'Encerramento graceful',
      modeGracefulHint: 'Pede-se ao sistema operativo guest que encerre de forma natural (ACPI); se ignorar o pedido, após o timeout segue-se a paragem forçada.',
      modeForced: 'Paragem forçada',
      modeForcedHint: 'Corta a corrente imediatamente, como tirar a ficha da tomada.',
      timeout: 'Timeout de fallback (segundos)',
      timeoutHint: 'Espera concedida ao guest antes de forçar a paragem'
    },
    createFromScratch: 'De raiz',
    createFromTemplate: 'A partir de template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Executar deploy',
      error: 'Deploy falhou',
      compatNote: 'O QuickDeploy exige um template compatível com QuickDeploy: a plataforma personaliza o guest (rede, domínio, ativação) no primeiro arranque.',
      template: 'Template',
      noTemplates: 'Nenhum template declara ainda compatibilidade QuickDeploy — declare-a no separador Templates (Linux com cloud-init, Windows com cloudbase-init após sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Nome de host',
      hostnameHint: 'Nome de host ou FQDN; vazio = o nome da VM (Windows: no máximo 15 caracteres)',
      ip: 'Endereço IP',
      ipHint: 'Host e prefixo, p. ex. 192.168.122.101/24; vazio = DHCP',
      gateway: 'Gateway',
      dns: 'Servidores DNS',
      dnsHint: 'Até três, separados por vírgulas',
      count: 'Instâncias',
      countHint: 'Mais do que uma: chamam-se <nome>-1…-N, apenas DHCP',
      user: 'Utilizador',
      userHint: 'Vazio = o utilizador predefinido da imagem (Linux) ou Administrator (Windows)',
      password: 'Palavra-passe',
      passwordHint: 'Escrita na user-data gerada, que a plataforma declara depois secreta: ninguém a volta a ler',
      sshKeys: 'Chaves públicas SSH',
      sshKeysHint: 'Uma por linha (ssh-ed25519 AAAA… comentário)',
      productKey: 'Chave de produto do Windows',
      kmsServer: 'Servidor KMS',
      kmsHint: 'Host ou host:porta — exige uma chave de produto (uma chave cliente KMS)',
      adDomain: 'Aderir ao domínio Active Directory',
      adDomainHint: 'Vazio = sem adesão ao domínio',
      adUser: 'Conta de adesão',
      adPassword: 'Palavra-passe da conta de adesão',
      adOu: 'OU de destino (opcional)',
      advanced: 'Avançado: documentos em bruto',
      userData: 'user-data (em bruto)',
      userDataHint: 'Substitui a user-data gerada: utilizador, palavra-passe, chaves e campos Windows acima devem ficar vazios',
      networkConfig: 'network-config (em bruto)',
      networkConfigHint: 'Substitui a rede gerada: IP, gateway e DNS acima devem ficar vazios',
      secret: 'Tratar a user-data em bruto como secreta',
      secretHint: 'Marcada como secreta, a API deixa de a devolver a quem quer que seja e viaja no Checkpoint selada com a masterpass',
      startNow: 'Iniciar de imediato',
      startNowHint: 'Cada instância arranca assim que fica definida; o seed nasce nesse arranque'
    },
    create: {
      nicAttachmentNetwork: 'Rede lógica (fabric)',
      nicNetwork: 'Rede lógica',
      nicNetworkHint: 'A via RECOMENDADA (F3): a vNIC realiza-se no bridge DERIVADO do nó servidor — o bridge nasce no apply explícito da fabric, e um arranque num nó que ainda não o carrega recusa falando. Quando a última referência da frota se vai, o bridge cai no próximo apply.',
      button: 'Criar VM',
      title: 'Criar máquina virtual',
      dialogTitle: 'Criar máquina virtual',
      stepGeneral: 'Geral',
      stepGeneralHint: 'Nome e perfil',
      stepCompute: 'CPU e RAM',
      stepComputeHint: 'Topologia e dimensionamento',
      stepDisks: 'Discos',
      stepDisksHint: 'Criar ou ligar',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Leitores e suportes',
      stepNetwork: 'Rede',
      stepNetworkHint: 'NICs: trunk ou bridge',
      stepSummary: 'Resumo',
      stepSummaryHint: 'Rever e criar',
      name: 'Nome',
      nameHint: 'Minúsculas, dígitos e hífenes (DNS-1123)',
      nextButton: 'Seguinte',
      prevButton: 'Anterior',
      submitButton: 'Criar',
      creating: 'A criar…',
      sockets: 'Sockets',
      cores: 'Cores por socket',
      threads: 'Threads por core',
      totalVcpus: 'vCPU totais',
      memoryGib: 'Memória (GiB)',
      cpuModelHint: "'host' expõe o CPU do host",
      cpuLimitHint: 'Teto em cores do host — vazio = ilimitado',
      cpuNestedHint: "Expõe vmx/svm ao convidado para que possa executar o seu próprio hipervisor — requer o modelo de CPU host e um nó com nested ativado",
      newDisk: 'Novo disco',
      attachDisk: 'Ligar disco existente',
      diskStorage: 'Storage',
      diskSize: 'Tamanho (GiB)',
      diskSelect: 'Disco',
      addDisk: 'Adicionar disco',
      addCdrom: 'Adicionar leitor CD/DVD',
      addNic: 'Adicionar interface de rede',
      remove: 'Remover',
      slotLimit: 'Limite de slots atingido',
      cdromImage: 'Imagem (leitor vazio se ausente)',
      nicAttachment: 'Ligação',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge do host',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Nenhuma (só tagged)',
      nicTrunkHint: 'Pelo menos um lado: uma overlay untagged e/ou mapeamentos VLAN tagged — a VM só pode correr nos hosts declarados por cada overlay referenciada',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Rede overlay',
      addTagged: 'Adicionar VLAN tagged',
      nicBridge: 'Nome da bridge do host',
      nicBridgeHint: 'Bridge NM por nome — a VM só pode correr nos servidores cuja rede host declara esta bridge',
      nicMac: 'MAC (auto se vazio)',
      noDisksHint: 'Nenhum disco: a VM terá apenas os leitores CD/DVD que adicionar.',
      noCdromsHint: 'Nenhum leitor CD/DVD: adicione um para arrancar de imagem ISO.',
      mountGuestTools: 'Montar TVirt Guest Tools no primeiro arranque',
      mountGuestToolsHint: 'Põe a ISO com os drivers virtio e o guest agent num leitor CD vazio (adicionado se necessário) — o installer do Windows precisa deles para ver os discos.',
      noNicsHint: 'Nenhuma interface de rede: a VM arrancará sem conectividade.',
      taggedMappings: 'Mapeamentos VLAN tagged',
      summaryDevices: 'Dispositivos',
      bootOrderTitle: 'Ordem de boot',
      bootOrderHint: 'Arraste para reordenar — vence o primeiro dispositivo arrancável; as NICs arrancam PXE',
      bootOrderUp: 'Mover para cima',
      bootOrderDown: 'Mover para baixo',
      createError: 'A criação falhou'
    },
    edit: {
      button: 'Editar',
      title: 'Editar máquina virtual',
      cancel: 'Cancelar',
      save: 'Guardar',
      error: 'A atualização falhou',
      modelStoppedOnly: 'Alterável só com a VM desligada',
      firmwareStoppedOnly: 'Firmware alterável só com a VM desligada — o próximo arranque usa o firmware novo e as variáveis UEFI permanecem',
      hugePagesStoppedOnly: 'Alterável apenas com a VM desligada — no próximo arranque a memória nasce com o novo suporte',
      runningHint: 'As alterações aplicam-se no próximo power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Memória',
      sectionPolicy: 'Políticas'
    },
    devices: {
      networkChip: 'rede fabric',
      title: 'Dispositivos',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Adicionar dispositivo USB',
      addUsbTitle: 'Exigir uma classe de dispositivos USB',
      usbClassHint: 'A VM pede uma CLASSE de dispositivos USB (um valor de uma tag usb-device), nunca um dispositivo concreto: no arranque escolhe-se e reserva-se o dispositivo livre concreto no nó escolhido. Marque com tags os dispositivos registados em Cluster › Recursos USB e PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Valor da classe',
      noUsbTags: 'Nenhuma tag usb-device — crie uma e marque os dispositivos registados em Cluster › Recursos USB e PCIe.',
      noUsbValues: 'Esta tag ainda não tem valores declarados.',
      usbEmpty: 'Nenhum requisito USB — adicione uma classe para passar um dispositivo no arranque.',
      usbClassChip: 'classe',
      usbPortChip: 'porta',
      usbUnclaimed: 'Nenhum dispositivo reservado — resolve-se no arranque da VM.',
      addGpu: 'Adicionar GPU',
      addGpuTitle: 'Exigir uma classe de GPU',
      gpuClassHint: 'A VM pede uma CLASSE de GPU (um valor de uma tag gpu-device), nunca uma placa concreta: no arranque a placa livre concreta é escolhida e reservada no nó, e passa JUNTO todo o seu grupo IOMMU. Marque com tags as GPUs registadas em Cluster › Recursos USB e PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Valor da classe',
      noGpuTags: 'Nenhuma tag gpu-device — crie uma e marque as GPUs registadas em Cluster › Recursos USB e PCIe.',
      noGpuValues: 'Esta tag ainda não tem valores declarados.',
      gpuEmpty: 'Nenhum requisito GPU — adicione uma classe para passar uma placa no arranque.',
      gpuClassChip: 'classe',
      gpuGroupChip: 'grupo IOMMU ×',
      gpuUnclaimed: 'Nenhuma placa reservada — resolve-se no arranque da VM.',
      gpuPowerCycle: 'Sem hotplug de GPU — as alterações valem a partir do próximo power cycle (PendingRestart)',
      actions: 'Ações',
      attachDisk: 'Adicionar disco',
      attachDiskTitle: 'Adicionar um disco',
      attach: 'Ligar',
      noFreeDisks: 'Nenhum disco não usado — crie um em Máquinas virtuais › Discos não usados.',
      addCdrom: 'Adicionar leitor',
      addCdromTitle: 'Adicionar um leitor CD/DVD',
      editCdromTitle: 'Mudar imagem CD/DVD',
      changeMedia: 'Mudar imagem CD/DVD',
      ejectMedium: 'Ejetar',
      mountGuestTools: 'Montar TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montadas',
      guestToolsClickMount: 'Põe a ISO TVirt Guest Tools no primeiro leitor CD/DVD vazio',
      guestToolsClickUnmount: 'Clique para ejetar — o leitor fica, vazio',
      guestToolsNoSlot: 'Nenhum leitor CD/DVD vazio — adicione um leitor (ou ejete um suporte) para montar as TVirt Guest Tools',
      guestToolsSkew: 'Montada a v{pinned}; o nó {node} serve agora a v{current}: ejete e volte a montar para atualizar',
      ejectGuestTools: 'Ejetar TVirt Guest Tools (o leitor fica, vazio)',
      guestToolsEjectConfirmTitle: 'Ejetar as TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'O suporte é ejetado da VM ligada — o leitor CD/DVD fica, vazio.',
      applyLive: 'Aplicar já (a VM está ligada)',
      addNic: 'Adicionar interface',
      addNicTitle: 'Adicionar uma interface de rede',
      editNicTitle: 'Editar interface de rede',
      bridgeChip: 'bridge',
      cable: 'Cabo virtual',
      plug: 'Ligar o cabo virtual',
      unplug: 'Desligar o cabo virtual',
      remove: 'Remover',
      removeTitle: 'Remover {device}?',
      removeBody: 'Com a VM ligada, a alteração aplica-se no próximo power cycle. Discos e imagens são desligados, nunca eliminados.'
    }
  }
}
